import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material'
@Component({
  selector: 'app-meeting-details-popup',
  templateUrl: './meeting-details-popup.component.html',
  styleUrls: ['./meeting-details-popup.component.css']
})
export class MeetingDetailsPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {


  }

}
